define(["data/config"], function(config) {
  var apply = function($element, params) {

    let $video = $element.find('.c_leadScanner-video');
    let $start = $element.find('.c_leadScanner-start');
    let $stop = $element.find('.c_leadScanner-stop');
    let $loggerWrapper = $element.find('.c_leadScanner-logger--wrapper');
    let $loggerInstructions = $element.find('.c_leadScanner-loggerInstructions');
    let $logger = $element.find('.c_leadScanner-logger');
    let $formScan = $element.find('.c_leadScanner-scanForm');
    let $formRate = $element.find('.c_leadScanner-rateForm');
    let $feedbackLoading = $element.find('.c_feedbackLoading');
    let $feedbackSuccess = $element.find('.c_feedbackSuccess');


    $stop.hide();

    let opts = {
      // Whether to scan continuously for QR codes. If false, use scanner.scan() to manually scan.
      // If true, the scanner emits the "scan" event when a QR code is scanned. Default true.
      continuous: true,

      // The HTML element to use for the camera's video preview. Must be a <video> element.
      // When the camera is active, this element will have the "active" CSS class, otherwise,
      // it will have the "inactive" class. By default, an invisible element will be created to
      // host the video.
      video: $video[0],

      // Whether to horizontally mirror the video preview. This is helpful when trying to
      // scan a QR code with a user-facing camera. Default true.
      mirror: false,

      // Whether to include the scanned image data as part of the scan result. See the "scan" event
      // for image format details. Default false.
      captureImage: false,

      // Only applies to continuous mode. Whether to actively scan when the tab is not active.
      // When false, this reduces CPU usage when the tab is not active. Default true.
      backgroundScan: false,

      // Only applies to continuous mode. The period, in milliseconds, before the same QR code
      // will be recognized in succession. Default 5000 (5 seconds).
      refractoryPeriod: 5000,

      // Only applies to continuous mode. The period, in rendered frames, between scans. A lower scan period
      // increases CPU usage but makes scan response faster. Default 1 (i.e. analyze every frame).
      scanPeriod: 5,
    };
    let scanner = new Instascan.Scanner(opts);

    let startCamera = function() {
      $video.show();
      Instascan.Camera.getCameras().then(function (cameras) {
        if (cameras.length > 1) {
          let cams = cameras.filter(function (c) { return c.name.toLowerCase().indexOf('front') === -1; });
          if (cams.length) {
            return scanner.start(cams[0]);
          }
        }
        if (cameras.length >= 1) {
          scanner.start(cameras[0]);
        } else {
          console.error('No cameras found.');
        }
      }).catch(function (e) {
        console.error(e);
      });
      $loggerWrapper.hide();
      $feedbackLoading.hide();
      $loggerInstructions.show();
      //$stop.show();
      //$start.hide();
    };

    let stopCamera = function() {
      scanner.stop();
      $video.hide();

      //$start.show();
      //$stop.hide();
    }

    scanner.addListener('scan', function (content) {
      stopCamera();
      $loggerInstructions.hide();
      $loggerWrapper.show();
      $feedbackLoading.hide();
      $logger.text("Processing QR code...");

      let url = $formScan.attr('action');
      $.ajaxSetup({headers: {"X-CSRF-Token": $('meta[name="_token"]').attr("content") }});
      $.post(url, {scan: content}, function(response) {

        let message = '';
        if (response.status == 'error') {
          message = 'Could not scan this badge..';
        } else {
          message = response.scanned + " has been successfully scanned.";
          if(!response.first) {
            message += " - Warning: You've already scanned this badge";
          } else {
            $feedbackSuccess.show();
          }
          $formRate.show();
          $formRate.find('.c_leadScanner-form-leadId').val(response.lead_id);
        }
        $logger.text(message);

        // if (response.status == 'failure') {
        //   $logger.text("Scan failed..."); // the confirm call blocks all threads, so the text wont show yet..
        //   again = confirm("Scanning failed, try again?");
        // } else {
        //   let message = "Successfully scanned " + response.scanned + " - ";
        //   message += response.first ? "new lead" : "existing lead";
        //   $logger.text(message); // the confirm call blocks all threads, so the text wont show yet..
        //   again = confirm(message + "\nScan another?");
        // }
      });
    });

    $start.on('click', function() {
      //$logger.text("Scanner is active");
      startCamera();
    });
    $stop.on('click', function() {
      //$logger.text("Use the button to start the scanner");
      stopCamera();
    });

    //$logger.text("Use the button to start the scanner");

    // $formRate.on('submit', function (ev) {
    //   ev.preventDefault();

    //   $.ajaxSetup({headers: {"X-CSRF-Token": $('meta[name="_token"]').attr("content") }});
    //   $.post($formRate.attr('action'), $formRate.serialize() , function(response) {
    //     if (response.status == 'success') {
    //       $logger.text(response.message);
    //     } else {
    //       $logger.text("There was an issue rating your lead");
    //     }
    //   });

    //   return false;
    // });
  };

  return {
    name: "leadScanner",
    apply: apply
  };
});
